jQuery(function() {
    var createPopUp, geocoder, listings, locatorElement;
    locatorElement = jQuery(".new-store-locator");
    if (locatorElement.length === 0) {
      return;
    }
    mapboxgl.accessToken = "pk.eyJ1Ijoic2NhcmJvcm91Z2hsdW1iZXIiLCJhIjoiY2wzazY5b2hnMDdpNDNpcWF6Z2Q4YnRsaCJ9.cWyV4n6E-gKZ6sdDIOIPKQ";
    window.map = new mapboxgl.Map({
      container: 'new-store-locator--map',
      zoom: 4,
      center: [-120.76725474492946, 39.067126671225424],
      style: "mapbox://styles/mapbox/light-v10"
    });
    geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      marker: false
    });
    map.addControl(geocoder);
    map.addControl(new mapboxgl.NavigationControl());
  
    listings = document.getElementById('listings');
    map.on("load", function() {
      map.addSource("locations", {
        type: "geojson",
        data: locatorElement.data("geojson"),
        cluster: true,
        clusterMaxZoom: 6
      });
      map.addLayer({
        id: "unclustered-point",
        type: "circle",
        source: "locations",
        filter: ["!has", "point_count"],
        paint: {
          "circle-color": "#0195e7",
          "circle-radius": 6,
          "circle-stroke-width": 2,
          "circle-stroke-color": "#fff"
        }
      });
      map.addLayer({
        id: "clusters",
        source: "locations",
        type: "circle",
        filter: ["has", "point_count"],
        paint: {
          "circle-color": "orange",
          "circle-radius": {
            property: "point_count",
            type: "interval",
            stops: [[0, 20], [100, 30], [750, 40]]
          },
          "circle-stroke-width": 4,
          "circle-stroke-color": "#fff"
        }
      });
      return map.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "locations",
        filter: ["has", "point_count"],
        paint: {
          "text-color": "#fff"
        },
        layout: {
          "text-field": "{point_count_abbreviated}",
          "text-size": 12
        }
      });
    });
    //  inspect a cluster on click
    map.on('click', 'clusters', function(e) {
      var clusterId, features;
      features = map.queryRenderedFeatures(e.point, {
        layers: ['clusters']
      });
      clusterId = features[0].properties.cluster_id;
      return map.getSource('locations').getClusterExpansionZoom(clusterId, function(err, zoom) {
        if (err) {
          return;
        }
        return map.easeTo({
          center: features[0].geometry.coordinates,
          zoom: zoom
        });
      });
    });
    // Add an event listener for when a user clicks on the map
    map.on('click', (e) => {
      var features;
      // Query all the rendered points in the view
      features = map.queryRenderedFeatures(e.point, {
        layers: ['unclustered-point']
      });
      console.log(features);
      if (features.length > 0) {
        createPopUp(features[0]);
      }
    });
    map.on('mouseenter', 'clusters', function() {
      return map.getCanvas().style.cursor = "pointer";
    });
    map.on('mouseleave', 'clusters', function() {
      return map.getCanvas().style.cursor = "";
    });
  
    return createPopUp = function(currentFeature) {
      var address, i, len, link, mapsHref, popUps, popup, product, ref, storeData, title;
      popUps = document.getElementsByClassName('mapboxgl-popup');
      if (popUps[0]) {
        // Check if there is already a popup on the map and if so, remove it
        popUps[0].remove();
      }
      storeData = currentFeature.properties;
      console.log(storeData);
      mapsHref = "http://maps.google.com/?daddr=" + [storeData.BusinessName,storeData.City].join(", ");
      console.log(mapsHref);
      title = '<h4>' + storeData.BusinessName + '</h4>';
      address = '<p>' + storeData.Address + ', ' + storeData.City + '<br />'+storeData.PhoneNumber+'</p>';
      link = '<a href="' + mapsHref + '" target="_blank">Get Directions</a>';
      // products = "<div class='products'>";
      // ref = eval(currentFeature.properties.products);
      // for (i = 0, len = ref.length; i < len; i++) {
      //   product = ref[i];
      //   products += "<div class='product-image " + "product-" + product + "'></div>";
      // }
      // products += "</div>";
      return popup = new mapboxgl.Popup({
        closeOnClick: false
      }).setLngLat(currentFeature.geometry.coordinates).setHTML(title + address + link ).addTo(map);
    };
  });
  